const getters = {
  selectedUser: state => {
    return state.selUser ? state.selUser : null
  },
  selectedInitiatorUser: state => {
    return state.initiator ? state.initiator : null
  },
}

export default getters
